// extracted by mini-css-extract-plugin
export default {"input-group-outlet":"inputGroupOutlet_input-group-outlet__HsUlz","input-group-outlet__secondaryTitle":"inputGroupOutlet_input-group-outlet__secondaryTitle__Ehw1r"};